import { TS_ItemType } from './TS_ItemType';
import { TS_Addon }    from './TS_Addon';

export class TS_Deposit extends TS_Addon {
    type = TS_ItemType.DEPOSIT;
}